import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { User, Role } from 'app/auth/models';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  //private
  public currentUserSubject: BehaviorSubject<User> = new BehaviorSubject<User>(null);

  //public
  public currentUser: Observable<User> = this.currentUserSubject.asObservable();

  /**
   *
   * @param {HttpClient} _http
   * @param {ToastrService} _toastrService
   */
  constructor(private _http: HttpClient, private _toastrService: ToastrService, private _router: Router) {
    this.currentUserSubject.next(JSON.parse(localStorage.getItem('currentUser')));
  }

  // getter: currentUserValue
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  /**
   *  Confirms if user is admin
   */
  get isAdmin() {
    return this.currentUser && this.currentUserSubject.value.role === Role.admin;
  }

  /**
   *  Confirms if user is client
   */
  get isClient() {
    return this.currentUser && this.currentUserSubject.value.role === Role.member;
  }

  /**
   * User login
   *
   * @param email
   * @param password
   * @returns user
   */
  login(email: string, password: string) {
    email = email.toLocaleLowerCase();
    return this._http
      .post<any>(`${environment.apiUrl}/auth/member/login`, { email, password })
      .pipe(
        map(resp => {
          // login successful if there's a jwt token in the response
          if (resp.data && resp.data.user) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(resp.data));
            // notify
            this.currentUserSubject.next(resp.data);
          } else {
            this.currentUserSubject.next(resp.data);
          }
          return resp;
        })
      );
  }

    /**
   * User register
   *
   * @param email
   * @param password
   * @returns user
   */
  register(formdata) {
    let email: string = formdata.email;
    email.toLowerCase();
    formdata.email = email;
    return this._http
      .post<any>(`${environment.apiUrl}/users/register`, formdata)
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && user.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));

            // notify
            // this.currentUserSubject.next(user);
          } else {

            // this.currentUserSubject.next(user);
          }

          return user;
        })
      );
  }
   /**
   * User forgot password
   *
   * @param email
   * @returns user
   */
  forgotPassword(email: string) {
    email = email.toLocaleLowerCase();
    return this._http
      .post<any>(`${environment.apiUrl}/auth/member/forgotPassword`, { email })
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && (user.success === 1)) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            // Display welcome toast!
            setTimeout(() => {
              this._toastrService.success(
                user.message,
                '!',
                { toastClass: 'toast ngx-toastr', closeButton: true }
              );
            }, 2500);

            // notify
            // this.currentUserSubject.next(user);
          } else {
            console.log('sadf')
            setTimeout(() => {
              this._toastrService.error(
                user.message,
              );

            }, 2500);

            // this.currentUserSubject.next(user);
          }

          return user;
        })
      );
  }
   /**
   * User forgot password
   *
   * @param email
   * @returns user
   */
  updatePassword(newPassword: string, userId: string, otpId: string) {
    return this._http
      .post<any>(`${environment.apiUrl}/auth/member/resetPassword`, { newPassword, userId, otpId })
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && (user.success === 1)) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            // Display welcome toast!
            setTimeout(() => {
              this._toastrService.success(
                user.message,
                '!',
                { toastClass: 'toast ngx-toastr', closeButton: true }
              );
            }, 2500);

            // notify
            // this.currentUserSubject.next(user);
          } else {
            console.log('sadf')
            setTimeout(() => {
              this._toastrService.error(
                user.message,
              );

            }, 2500);

            // this.currentUserSubject.next(user);
          }

          return user;
        })
      );
  }

  activateUser(userId: any, token: string) {
    return this._http
      .post<any>(`${environment.apiUrl}/users/activate-user`, {  userId, token })
      .pipe(
        map(user => {
          // login successful if there's a jwt token in the response
          if (user && (user.success === 1)) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes

            // Display welcome toast!
            setTimeout(() => {
              this._toastrService.success(
                user.message,
                '!',
                { toastClass: 'toast ngx-toastr', closeButton: true }
              );
            }, 2500);

          } else {
            setTimeout(() => {
              this._toastrService.error(
                user.message,
              );

            }, 2500);
          }

          return user;
        })
      );
  }
  /**
   * User logout
   *
   */
  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    // notify
    this.currentUserSubject.next(null);
  }


  /* Set user */
  setUser(user){
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
  }

  /* remove user */
  removeUser(){
    localStorage.removeItem('saga4562asda456ads');
  }

}
